/**
 * Created by RoryHe on 2020/7/2.
 * 常量
 */


/**
 * 文件类型
 *
 //身份证明材料
 MEDIATE_IDENTITY_10("10","身份证明材料-身份证件"),
 MEDIATE_IDENTITY_11("11","身份证明材料-律师执业证"),
 MEDIATE_IDENTITY_12("12","身份证明材料-授权委托书"),
 MEDIATE_IDENTITY_13("13","身份证明材料-律师事务所代理函"),
 MEDIATE_IDENTITY_14("14","身份证明材料-营业执照"),
 MEDIATE_IDENTITY_15("15","身份证明材料-金融许可证"),
 MEDIATE_IDENTITY_16("16","身份证明材料-法定代表人身份证明"),
 //证据材料
 INDICTMENT("1", "起诉状"),
 MEDIATE_EVIDENCE_20("20","证据材料-证据清单"),
 MEDIATE_EVIDENCE_21("21","证据材料-信用卡领用合约"),
 MEDIATE_EVIDENCE_22("22","证据材料-借据"),
 MEDIATE_EVIDENCE_23("23","证据材料-信用卡申领表"),
 MEDIATE_EVIDENCE_24("24","证据材料-交易明细"),
 MEDIATE_EVIDENCE_25("25","证据材料-借款合同"),
 MEDIATE_EVIDENCE_26("26","证据材料-数字签名验证报告或流程公证书"),

 //案件文书
 MEDIATE_APPLY_DOC("70": "调解申请书"),
 MEDIATE_NOTICE_DOC("71": "调解告知书"),
 MEDIATE_RECORD_DOC("72": "调解笔录"),
 MEDIATE_AGREEMENT_DOC("73": "调解协议"),
 JUDICIAL_CONFIRM_APPLY_DOC("74": "司法确认申请书"),
 DELIVERY_ADDRESS_CONFIRM_DOC("75": "送达地址确认书"),
 DELIVERY_ADDRESS_CONFIRM_DOC("76": "司法确认承诺书"),

 LICENSE("2","营业执照复印件"),
 LEGAL_CERTIFICATE("3","法定代表人身份证明"),
 FINANCIAL_LICENSE("7","金融许可证"),
 **/
export const FILE_TYPE = {
  "70": "调解申请书",
  "71": "调解告知书",
  "72": "调解笔录",
  "73": "调解协议",
  "74": "司法确认申请书",
  "75": "送达地址确认书",
  "76": "司法确认承诺书",
  // 身份证明材料
  "10": "身份证件",
  "11": "律师执业证",
  "12": "授权委托书",
  "13": "律师事务所代理函",
  "14": "营业执照",
  "15": "金融许可证",
  "16": "法定代表人身份证明",
  // 案件及证据材料
  "20": "证据清单",
  "21": "信用卡领用合约",
  "22": "借据",
  "23": "信用卡申领表",
  "24": "交易明细",
  "25": "借款合同",
  "26": "数字签名验证报告或流程公证书",

  '99': '其他证据',
  '51': '信用卡领用合约',
  '1': '起诉状',
}
export const YS_FILE_TYPE = {
  "1": "起诉状",
  "20": "证据清单",
  "21": "信用卡领用合约",
  "22": "借据",
  "23": "信用卡申领表",
  "24": "交易明细",
  "25": "借款合同",
  "26": "数字签名验证报告或流程公证书",
  '99': '其他证据',
}
export const YS_FILE_TYPE_CODE = ['1','20','21','22','23','24','25','26','99']
// 司法确认的文件类型
export const FILE_TYPE_APPLY_JUDICIAL_CONFIRMATION = {
  /* 身份证明材料 */
  '4': '授权委托书',
  '8': '身份证明材料',
  '60': '身份证明材料',
  '5': '代理律师执业证',
  '6': '律师事务所诉讼代理函',
  '2': '营业执照复印件',
  '7': '金融许可证',
  '3': '法定代表人身份证明',

  /* 诉讼材料 */
  "72": "调解笔录",
  "73": "调解协议",
  '74': '司法确认申请书',
  '76': '司法确认承诺书',
  '11': '调解笔录',
  '12': '调解协议',
  '20': '保险许可证',
  '75': '送达地址确认书',

  /* 证据材料 */
  '54': '证据清单',
  '51': '信用卡领用合约',
  '52': '信用卡申领表',
  '53': '交易明细',
  '55': '借据',
  '99': '其他',
}
export const FILE_TYPE_YZW_APPLY_JUDICIAL_CONFIRMATION = {
  /* 身份证明材料 */
  '4': '授权委托书',
  '8': '当事人身份证明材料',
  '60': '委托代理人身份证明材料',
  '5': '代理律师执业证',
  '6': '律师事务所诉讼代理函',
  '2': '营业执照复印件',
  '3': '法定代表人身份证明',

  /* 诉讼材料 */
  "72": "调解笔录",
  "73": "调解协议",
  '74': '司法确认申请书',
  '76': '司法确认承诺书',
  '12': '调解协议',
  '11': '调解笔录',
  '7': '金融许可证',
  '20': '保险许可证',
  '75': '送达地址确认书',

  /* 证据材料 */
  '54': '证据清单',
  '51': '信用卡领用合约',
  '52': '信用卡申领表',
  '53': '交易明细',
  '55': '借据',
  '99': '其他',
}
/**
 * 批量文书上传的匹配文件名称及类型
 * 送达地址确认书的匹配单独处理
 */
export const BATCH_TYPE = [
  {"70": "调解申请书"},
  {"70": "申请登记表"},
  {"71": "告知"},//调解告知书
  {"71": "提示"},//调解告知书
  {"72": "笔录"},//调解笔录
  {"73": "调解协议",},//调解协议书
  {"74": "司法确认申请书",},
  // {"75": "送达地址",},//送达地址确认书
  {"76": "司法确认承诺书"},
]

/**
 * 批量文书上传的送达地址确认书文件类型
 * @type {string}
 */
export const BATCH_USER_FILE_TYPE = '75'
/**
 * 批量文书上传的送达地址确认书文件匹配关键词
 * @type {string}
 */
export const BATCH_USER_FILE_NAME = '送达地址'


/**
 * 场景类型(1身份证明材料2证据材料3案件文书)
 */
export const SCENES_TYPE = {
  '1': '身份证明材料',
  '2': '证据材料',
  '3': '案件文书'
}
/**
 * 用户类型(用户类型:1原告2被告3原告代理人4被告代理人)
 */
export const USER_TYPE = {
  '1': '申请人',
  '2': '被申请人',
  '3': '申请人代理人',
  '4': '被申请人代理人'
}

// 纠纷类型
export const loanContractDisputes = '9178001';  // 金融借款合同纠纷
export const netLoanContractDisputes = '6669178' // 互联网金融借款合同纠纷

export const creditCardDisputes = '9193' // 信用卡纠纷

export const cyclicCreditDisputes = '9178002' // 循环授信业务纠纷

export const creditCardCause = '9193' // 信用卡案由 --- 用于非诉

export const dftCount = 10 // 被告最大可添加个数

export const plaintiffAgtCount = 2 // 原告代理人最大可添加个数

export const dftAgtCount = 2 // 被告代理人最大可添加个数

export const laywerAgtType = '1' // 代理人类型 = 律师

export const otherIdentification = '1024' // 其他人身份code码值

export const videoStatus = '1025' // 调解视频间状态查询

export const smallLoanContractDisputes = '9182' // 小额借款
export const netSmallLoanContractDisputes = '6669182' // 互联网小额借款

export const mapConfigTypeCode = '8048'

/**
 * 单值代码
 */
export const pltLicenceType = '11102017' // 证照类型
export const pltLicenceTypeBrt = '11400032' // 证照类型 brt
export const agtType = '11150173' // 代理人类型
export const lawyerLicenseType = '11401845' // 律师执业类别
export const sex = '11400000' // 性别
export const nation = '11401164' // 民族
export const credentialType = '11400022' // 证件类型
export const roleList = '1020' // 角色
export const contactType = '1005' // 联系方式类别

/**
 * 单值代码
 */
export const Times = 86400000 // 一天时间毫秒数

export const cache_crrentActId = 'crrentActId' // 缓存用key

/**
 * 调解2.6 案件状态-代理人端
 * 案件状态，1待分，2不予受理，3未触达，5调解中，6已达成方案，7已签署协议，8已申请确认，9调解失败，40待提交，50待审核(已提交)，60审核未通过，70审核通过
 */
export const case_status = [
  {label: '待提交', value: '40'},
  {label: '已提交', value: '50'},
  {label: '审核未通过', value: '60'},
  {label: '审核通过', value: '1'},
  {label: '调解中', value: '5'},
  // {label: '已达成方案', value: '6'},
  {label: '已签署协议', value: '7'},
  // { label: '已申请确认', value: '8' },
  {label: '调解成功', value: '10'},
  {label: '调解失败', value: '9'},
]
export const case_status_judicial_confirmation = [
  {label: '待提交', value: '1'},
  {label: '待审核', value: '2'},
  {label: '审核未通过', value: '3'},
  {label: '审核通过', value: '8'},
  {label: '已立案', value: '4'},
  {label: '审理中', value: '5'},
  {label: '已结案', value: '6'},
]

// 失败原因 1-材料不完整，2-不予受理，3-其他
export const failure_reason = [
  // { label: '全部', value: '' },
  {label: '材料不完整', value: '1'},
  {label: '不予受理', value: '2'},
  {label: '其他', value: '3'}
]

export const back_flag = [
  {label: '未撤回/退回', value: false},
  {label: '已撤回/退回', value: true},
]

// 司法确认
export const failure_judicial = [
  {label: '未发起申请', value: '1'},
  {label: '已发起申请', value: '2'},
  {label: '已给予确认', value: '3'},
  {label: '未给予确认', value: '4'}
]

// 自助签约
export const SELF_SERVICE_SIGNING = [
  {label: '全部', value: ''},
  {label: '未发起', value: '0'},
  {label: '已发起-未确认方案', value: '1'},
  {label: '已发起-文书不合格', value: '2'},
  {label: '已发起-对方签约中', value: '3'},
  {label: '已发起-对方已签约', value: '4'},
  {label: '已发起-调解员签约中', value: '5'}
]

/**
 *  HAS_NOT_STARTED(1, "未开始"),
 PROGRESS(2, "进行中"),
 PAUSE(3, "暂停"),
 FINISH(4, "结束"),
 NEGLECT(5, "忽略"),
 ABNORMAL(6, "任务异常"),
 */
export const taskStatusEnum = {
  1: '未开始',
  2: '进行中',
  3: '暂停',
  4: '结束',
  5: '忽略',
  6: '任务异常',
}

export const systemTOHeader = {
  'xmdftjft': '厦门市地方金融调解中心'
}

// 固定电话code
export const FixedTelCode = '2'
export const FixedTelReg = /^\d{3,4}[-－]\d{7,8}$/
// 移动电话code
export const MobileTelCode = '1'
export const MobileTelReg = /^1[3456789]\d{9}$/

// 人员类型
// 被申请人-自然人
export const DEFENDANT_NATURAL = 1
// 被申请人-法人
export const DEFENDANT_LEGAL = 2
// 申请人-自然人
export const PLAINTIFF_NATURAL = 3
// 申请人-法人
export const PLAINTIFF_LEGAL = 4

export const configType = 'ys'


export const customComponentTypes = [
  {
    name: '标题',
    code: 'title'
  },
  {
    name: '单行文本',
    code: 'text'
  },
  {
    name: '多行文本',
    code: 'textarea'
  },
  {
    name: '金额',
    code: 'decimal'
  },
  {
    name: '利率',
    code: 'rate'
  },
  {
    name: '单选',
    code: 'radio'
  },
  {
    name: '多选',
    code: 'checkbox'
  },
  {
    name: '下拉框',
    code: 'select'
  },
  {
    name: '自定义下拉下拉框',
    code: 'custom_select'
  },
  {
    name: '级联',
    code: 'cascader'
  },
  {
    name: '日期',
    code: 'date_picker'
  },
  {
    name: '自定义文本',
    code: 'custom_text'
  },
  {
    name: '分隔符',
    code: 'divider'
  },
  {
    name: '手机号',
    code: 'phone'
  },
  {
    name: '邮箱',
    code: 'email'
  },
  {
    name: '密码',
    code: 'password'
  },
  {
    name: '上传',
    code: 'upload'
  },
  {
    name: '按钮',
    code: 'button'
  },
  {
    name: '容器',
    code: 'container_layout'
  },
  {
    name: '表单容器',
    code: 'card_form'
  },
  {
    name: '表格容器',
    code: 'table_form'
  },
]
